import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import ApiEndpoints from "../../../constants/api_endpoints";
import { setSuccess, setError, setLoader } from "../../../actions/action-creators";
import store from "../../../store";
import { Chip, Icon, TablePagination } from "@material-ui/core";
import moment from "moment";

class ServicePurchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceData: [],
      isFilters: {},
      isshowOrderDetails: false,
      selectedOrder: null
    };
  }

  async componentDidMount() {
    this.fetchServiceReport();
  }


  fetchServiceReport = async () => {
    store.dispatch(setLoader(true));

    try {
      var param = {
        user_id: this.props.user_id
      }
      let apiData = await ApiEndpoints.ServicePurchase.fetchData(param);
      let serviceData = apiData.data.data;
      await this.setState({ serviceData });
    }
    catch (e) {
      store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
    }
    store.dispatch(setLoader(false))
  }

  fetchOrderDetails = async (order) => {
    store.dispatch(setLoader(true));

    try {
      var param = {
        user_id: this.props.user_id,
        order_id: order.order_id
      }
      let apiData = await ApiEndpoints.ServicePurchase.fetchOrderData(param);
      let orderData = apiData.data.data;
      await this.setState({ selectedOrder: { ...order, orderData, ...orderData.details } });
    }
    catch (e) {
      store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }))
    }
    store.dispatch(setLoader(false))
  }








  render() {
    let { serviceData, selectedOrder } = this.state;

    return (


      !selectedOrder ?
        serviceData.map(recharge => {
          return (
            <div style={{ fontSize: 14, borderRadius: 12 }} className="bg-light border px-2 py-1 my-2 clickable"
              onClick={() => this.fetchOrderDetails(recharge)}
            >
              <Row className="align-items-center">
                <Col xs={1} className="text-left">
                  <img className="rounded-circle" style={{ width: 35, aspectRatio: "1" }} src={recharge.logo_url} alt="Logo Pic.." />
                </Col>
                <Col xs={8}>
                  <div className="pl-2">
                    <span className="font-weight-bold d-block">{recharge.heading}</span>
                    <span className="small d-block">{recharge.subheading}</span>

                  </div>
                </Col>
                <Col xs={3} className="text-right">
                  <span className="small font-weight-bold" style={{ fontSize: 15 }}>₹{recharge.amount}</span>

                </Col>
              </Row>
              <Row className="align-items-center">
                <Col xs={8}>
                  <span className="d-block" style={{ fontSize: 10 }}>{recharge.reference_label}</span>
                  <span className="small font-weight-bold" style={{ fontSize: 12 }}>{recharge.reference_value}</span>
                </Col>
                <Col xs={4} className="text-right">
                  <span className="d-block" style={{ fontSize: 10 }}>{moment(recharge.created_on).utcOffset("+05:30").format("Do MMM'YY HH:mm A")}</span>

                  <div><span className="d-block" style={{ fontSize: 12 }}>
                    <b>

                      {recharge.pg_refund_status === "Refund SUCCESS" ? <span style={{ color: "#2632b5ff" }}>{recharge.pg_refund_status}</span>
                        :
                        <>
                          {recharge.status === 50 && <span style={{ color: "#4BB543" }}>{recharge.order_status}</span>}
                          {recharge.status === 30 && <span style={{ color: "#e9a84c" }}>{recharge.order_status}</span>}
                          {recharge.status === 40 && <span style={{ color: "#b52023" }}>{recharge.order_status}</span>}
                        </>
                      }
                    </b>
                  </span>
                  </div>
                </Col>
              </Row>

            </div>
          )
        })
        :
        <div>
          <span className="m-2 d-block pb-2 border-bottom">
            <Icon fontSize="small" style={{ cursor: "pointer" }} className="mr-3 align-middle" onClick={() => this.setState({ selectedOrder: null })}>arrow_back</Icon>
            {selectedOrder.orderData.biller_category}
          </span>
          <div className="bg-light border px-7 py-1 my-7">
            <Row className="align-items-center border-bottom">
              <Col>
                <span className="font-weight-bold d-block" style={{ fontSize: 17 }}>₹ {selectedOrder.orderData.bill_amount} Amount Paid to</span>
                <span className="small d-block " style={{ fontSize: 10 }}>{selectedOrder.orderData.biller_name}</span>
              </Col>
            </Row>
            <Row>
              <Row className="align-items-center">
                <Col xs={6} className="text-left">
                  <Col>
                    {selectedOrder.orderData.details.map((item, i) =>
                      i % 2 === 0 ? (
                        <Col key={i}>
                          <span className="d-block" style={{ fontSize: 10 }}> {item.label}</span>
                          <span className="small font-weight-bold" style={{ fontSize: 10 }}> {item.value}</span>
                        </Col>
                      ) : null
                    )}
                  </Col>
                </Col>

                <Col xs={6} className="text-right align-items-right">
                  <Col>
                    {selectedOrder.orderData.details.map((item, i) =>
                      i % 2 === 1 ? (
                        <Col key={i}>
                          <span className="d-block" style={{ fontSize: 10 }}>{item.label}</span>
                          <span className="small font-weight-bold" style={{ fontSize: 10 }}>{item.value}</span>
                        </Col>
                      ) : null
                    )}
                  </Col>
                </Col>
              </Row>
            </Row>



          </div>
        </div>



    )

  }

}
export default { ServicePurchase }

